<template>
  <div ref="pageView" class="page-view container-view" v-loading="loading">
    <section class="title-section fixed-view">
      <e6-title>
        新增应急任务
      </e6-title>
    </section>
    <section class="container-section">
      <el-form ref="form" :model="formData" label-width="130px">
        <!-- 任务信息 -->
        <div class="item">
          <p class="item-title">任务信息</p>
          <div class="item-content">
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item
                  label="任务ID"
                  prop="name"
                  :rules="[
                    {
                      required: true,
                      message: '请输入任务ID',
                      trigger: 'blur'
                    }
                  ]"
                >
                  <el-input
                    v-model="formData.name"
                    :disabled="isDsiabled"
                  ></el-input> </el-form-item
              ></el-col>
              <el-col :span="12">
                <el-form-item
                  label="任务车辆通行证"
                  prop="name"
                  :rules="[
                    {
                      required: true,
                      message: '请输入任务车辆通行证',
                      trigger: 'blur'
                    }
                  ]"
                >
                  <el-input
                    v-model="formData.name"
                    :disabled="isDsiabled"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
        <div class="item handle-cargo">
          <!-- 发货信息 -->
          <div class="item-left">
            <p class="item-title send">发货信息</p>
            <div class="item-content">
              <el-form-item
                label="发货地址"
                prop="name"
                :rules="[
                  {
                    required: true,
                    message: '请输入',
                    trigger: 'blur'
                  }
                ]"
              >
                <el-input
                  v-model="formData.name"
                  :disabled="isDsiabled"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="联系人"
                prop="name"
                :rules="[
                  {
                    required: true,
                    message: '请输入',
                    trigger: 'blur'
                  }
                ]"
              >
                <el-input
                  v-model="formData.name"
                  :disabled="isDsiabled"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="联系电话"
                prop="name"
                :rules="[
                  {
                    required: true,
                    message: '请输入',
                    trigger: 'blur'
                  }
                ]"
              >
                <el-input
                  v-model="formData.name"
                  :disabled="isDsiabled"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="起运时间"
                prop="name"
                :rules="[
                  {
                    required: true,
                    message: '请输入',
                    trigger: 'blur'
                  }
                ]"
              >
                <el-date-picker
                  :disabled="isDsiabled"
                  v-model="formData.time"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  align="right"
                >
                </el-date-picker>
              </el-form-item>
            </div>
          </div>
          <!-- 收货信息 -->
          <div class="item-right">
            <p class="item-title receive">收货信息</p>
            <div class="item-content">
              <el-form-item
                label="收货地址"
                prop="name"
                :rules="[
                  {
                    required: true,
                    message: '请输入',
                    trigger: 'blur'
                  }
                ]"
              >
                <el-input
                  v-model="formData.name"
                  :disabled="isDsiabled"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="联系人"
                prop="name"
                :rules="[
                  {
                    required: true,
                    message: '请输入',
                    trigger: 'blur'
                  }
                ]"
              >
                <el-input
                  v-model="formData.name"
                  :disabled="isDsiabled"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="联系电话"
                prop="name"
                :rules="[
                  {
                    required: true,
                    message: '请输入',
                    trigger: 'blur'
                  }
                ]"
              >
                <el-input
                  v-model="formData.name"
                  :disabled="isDsiabled"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="送达时间"
                prop="name"
                :rules="[
                  {
                    required: true,
                    message: '请输入',
                    trigger: 'blur'
                  }
                ]"
              >
                <el-date-picker
                  :disabled="isDsiabled"
                  v-model="formData.time"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  align="right"
                >
                </el-date-picker>
              </el-form-item>
            </div>
          </div>
        </div>
        <!-- 货物信息 -->
        <div class="item">
          <p class="item-title">货物信息</p>
          <div class="item-content" v-if="isDsiabled === false">
            <el-row>
              <el-table :data="formData.tableData">
                <el-table-column
                  prop="name"
                  label="货物名称"
                  align="center"
                  min-width="230"
                  class-name="cargo-name"
                >
                  <el-form-item slot-scope="scope">
                    <el-input
                      v-model="formData.tableData[scope.$index].name"
                      placeholder="请输入货物名称"
                      clearable
                    />
                  </el-form-item>
                </el-table-column>
                <el-table-column
                  prop="num"
                  label="数量"
                  align="center"
                  min-width="120"
                  class-name="cargo-num"
                >
                  <el-form-item slot-scope="scope">
                    <el-input
                      v-model="formData.tableData[scope.$index].num"
                      clearable
                    />
                  </el-form-item>
                </el-table-column>
                <el-table-column
                  prop="unit"
                  label="单位"
                  align="center"
                  min-width="90"
                  class-name="cargo-unit"
                >
                  <el-form-item slot-scope="scope">
                    <el-input
                      v-model="formData.tableData[scope.$index].unit"
                      clearable
                    />
                  </el-form-item>
                </el-table-column>
                <el-table-column
                  prop="weight"
                  label="重量"
                  align="center"
                  min-width="120"
                  class-name="cargo-weight"
                >
                  <el-form-item slot-scope="scope">
                    <el-input
                      v-model="formData.tableData[scope.$index].weight"
                      clearable
                    />
                  </el-form-item>
                </el-table-column>
                <el-table-column
                  prop="volume"
                  label="体积"
                  align="center"
                  min-width="120"
                  class-name="cargo-volume"
                >
                  <el-form-item slot-scope="scope">
                    <el-input
                      v-model="formData.tableData[scope.$index].volume"
                      clearable
                    />
                  </el-form-item>
                </el-table-column>
                <el-table-column
                  prop="tempRequire"
                  label="温度要求（℃）"
                  align="center"
                  min-width="160"
                  class-name="cargo-temp"
                >
                  <el-form-item slot-scope="scope">
                    <el-input
                      v-model="formData.tableData[scope.$index].lowTem"
                      placeholder="最低温"
                      clearable
                    />
                  </el-form-item>
                  <el-form-item slot-scope="scope">
                    <el-input
                      v-model="formData.tableData[scope.$index].highTem"
                      placeholder="最高温"
                      clearable
                    />
                  </el-form-item>
                </el-table-column>
                <el-table-column
                  prop="humRequire"
                  label="湿度要求（%RH）"
                  align="center"
                  min-width="160"
                  class-name="cargo-hum"
                >
                  <el-form-item slot-scope="scope">
                    <el-input
                      v-model="formData.tableData[scope.$index].lowHum"
                      placeholder="最低湿"
                      clearable
                    />
                  </el-form-item>
                  <el-form-item slot-scope="scope">
                    <el-input
                      v-model="formData.tableData[scope.$index].highHum"
                      placeholder="最高湿"
                      clearable
                    />
                  </el-form-item>
                </el-table-column>
                <el-table-column
                  prop="remake"
                  label="货物备注"
                  align="center"
                  min-width="305"
                  class-name="cargo-remake"
                >
                  <el-form-item slot-scope="scope">
                    <el-input
                      v-model="formData.tableData[scope.$index].remake"
                      clearable
                    />
                  </el-form-item>
                </el-table-column>
                <el-table-column align="center" width="80">
                  <template slot-scope="scope">
                    <i
                      title="删除货物信息"
                      v-if="scope.$index"
                      class="e6-icon-delete_line cargo-delete"
                      @click="handleDeleteCargoInfo(scope)"
                    ></i>
                  </template>
                </el-table-column> </el-table
            ></el-row>
            <el-row class="add-msg">
              <span @click="handleAddCargoInfo()"
                ><i class="e6-icon-add_line"></i>新增货物信息</span
              >
            </el-row>
          </div>

          <div class="item-content" v-else>
            <el-table :data="formData.tableData">
              <el-table-column
                prop="name"
                label="货物名称"
                align="center"
                min-width="230"
                class-name="cargo-name"
              >
              </el-table-column>
              <el-table-column
                prop="num"
                label="数量"
                align="center"
                min-width="120"
                class-name="cargo-num"
              >
              </el-table-column>
              <el-table-column
                prop="unit"
                label="单位"
                align="center"
                min-width="90"
                class-name="cargo-unit"
              >
              </el-table-column>
              <el-table-column
                prop="weight"
                label="重量"
                align="center"
                min-width="120"
                class-name="cargo-weight"
              >
              </el-table-column>
              <el-table-column
                prop="volume"
                label="体积"
                align="center"
                min-width="120"
                class-name="cargo-volume"
              >
              </el-table-column>
              <el-table-column
                prop="tempRequire"
                label="温度要求（℃）"
                align="center"
                min-width="160"
                class-name="cargo-temp"
              >
              </el-table-column>
              <el-table-column
                prop="humRequire"
                label="湿度要求（%RH）"
                align="center"
                min-width="160"
                class-name="cargo-hum"
              >
              </el-table-column>
              <el-table-column
                prop="remake"
                label="货物备注"
                align="center"
                min-width="305"
                class-name="cargo-remake"
              >
              </el-table-column>
            </el-table>
          </div>
        </div>
        <!-- 运输车信息 -->
        <div class="item">
          <p class="item-title">运输车辆信息</p>
          <div class="item-content">
            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item
                  label="运输车辆"
                  prop="name"
                  :rules="[
                    {
                      required: true,
                      message: '请输入',
                      trigger: 'blur'
                    }
                  ]"
                >
                  <el-input v-model="formData.name"></el-input> </el-form-item
              ></el-col>
              <el-col :span="12">
                <el-form-item
                  label="所属企业"
                  prop="name"
                  :rules="[
                    {
                      required: true,
                      message: '请输入',
                      trigger: 'blur'
                    }
                  ]"
                >
                  <span></span>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row :gutter="24">
              <el-col :span="12">
                <el-form-item
                  label="司机"
                  prop="name"
                  :rules="[
                    {
                      required: true,
                      message: '请输入',
                      trigger: 'blur'
                    }
                  ]"
                >
                  <el-input v-model="formData.name"></el-input> </el-form-item
              ></el-col>
              <el-col :span="12">
                <el-form-item
                  label="联系方式"
                  prop="name"
                  :rules="[
                    {
                      required: true,
                      message: '请输入',
                      trigger: 'blur'
                    }
                  ]"
                >
                  <el-input v-model="formData.name"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>
    </section>
    <section class="footer-section">
      <el-button type="primary" size="small" @click="handleSubmit()">{{
        isDsiabled === "false" ? 发布新应急任务 : "接受应急任务"
      }}</el-button>
      <el-button
        size="small"
        @click="$router.push('emergencyManageTaskManageList')"
        >取消</el-button
      >
    </section>

    <el-dialog
      :visible.sync="dialogVisible"
      width="700px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div class="wrapper">
        <el-form :model="detailForm">
          <h3 class="main-title">
            郑州市政府应急任务通行证
          </h3>
          <div class="dialog-item">
            <div class="dialog-item-title">车辆信息</div>
            <div class="dialog-item-content">
              <el-row :gutter="24">
                <el-col :span="24">
                  <el-form-item label="任务车辆通行证"
                    >RW20200402008</el-form-item
                  ></el-col
                ></el-row
              >
              <el-row :gutter="24">
                <el-col :span="12"
                  ><el-form-item label="运输车辆"
                    >RW20200402008</el-form-item
                  ></el-col
                ><el-col :span="12"
                  ><el-form-item label="司机"
                    >RW20200402008</el-form-item
                  ></el-col
                ></el-row
              >
              <el-row :gutter="24">
                <el-col :span="12"
                  ><el-form-item label="驾驶证号"
                    >RW20200402008</el-form-item
                  ></el-col
                ><el-col :span="12"
                  ><el-form-item label="身份证号"
                    >RW20200402008</el-form-item
                  ></el-col
                ></el-row
              >
            </div>
          </div>
          <div class="dialog-item">
            <div class="dialog-item-title">任务信息</div>
            <div class="dialog-item-content task-msg">
              <div class="item-content_left">
                <p class="title">发货信息</p>
                <div class="content">
                  <el-form-item label="发货区域">RW20200402008</el-form-item>
                  <el-form-item label="联系人">RW20200402008</el-form-item>
                  <el-form-item label="联系电话">RW20200402008</el-form-item>
                  <el-form-item label="起运时间">RW20200402008</el-form-item>
                </div>
              </div>
              <div class="item-content_right">
                <p class="title">收货信息</p>
                <div class="content">
                  <el-form-item label="收货区域">RW20200402008</el-form-item>
                  <el-form-item label="联系人">RW20200402008</el-form-item>
                  <el-form-item label="联系电话">RW20200402008</el-form-item>
                  <el-form-item label="起运时间">RW20200402008</el-form-item>
                </div>
              </div>
            </div>
          </div>
          <div class="dialog-item">
            <div class="dialog-item-title">货物信息</div>
            <div class="dialog-item-content table">
              <table class="tables" border="1" cellspacing="0">
                <thead>
                  <tr>
                    <th width="100">货物名称</th>
                    <th width="70">数量</th>
                    <th>重量（吨）</th>
                    <th>体积（㎡）</th>
                    <th>温度要求</th>
                    <th>湿度要求</th>
                    <th>货物备注</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="i in 3" :key="i">
                    <td width="100">西红柿</td>
                    <td width="70">25件</td>
                    <td>0.5</td>
                    <td>0.5</td>
                    <td>5 ℃ - 15℃</td>
                    <td>1%RH - 66%RH</td>
                    <td>
                      请务必按照温湿度要求进行运输！
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </el-form>
        <div class="image"></div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      formData: {
        name: "",
        time: [],
        tableData: [
          {
            name: "eee",
            num: 12,
            unit: "",
            weight: "",
            volume: "",
            tempRequire: {
              lowTemp: "",
              highTemp: ""
            },

            humRequire: {
              lowHum: "",
              highHum: ""
            },
            remake: ""
          }
        ]
      },

      detailForm: {
        vehicleCode: "",
        vehicleID: "",
        driverName: "",
        driverCard: "",
        driverIDCard: ""
      },

      cargoTemplateObj: {
        name: "eee",
        num: 12,
        unit: "",
        weight: "",
        volume: "",
        tempRequire: {
          lowTemp: "",
          highTemp: ""
        },

        humRequire: {
          lowHum: "",
          highHum: ""
        },
        remake: ""
      }
    };
  },

  computed: {
    isDsiabled() {
      if (this.$route.query.detail) {
        return true;
      } else {
        return false;
      }
    }
  },

  methods: {
    // 增加货物信息
    handleAddCargoInfo() {
      this.formData.tableData.push(this.cargoTemplateObj);
    },

    // 删除货物信息
    handleDeleteCargoInfo(obj) {
      this.formData.tableData.splice(obj.$index, 1);
    },

    // 提交
    handleSubmit() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
        this.$message.success("操作成功");

        this.dialogVisible = true;
        setTimeout(() => {
          this.dialogVisible = false;
          this.$router.push("emergencyManageTaskManageList");
        }, 3000);
      }, 2000);
    }
  }
};
</script>

<style lang="scss" scoped>
// 主体页面
.page-view {
  height: 100%;

  // 标题
  .title-section {
    padding: 15px 20px 0;
  }

  // 内容
  .container-section {
    height: calc(100% - 44px - 70px);
    overflow: auto;

    // 表单区域
    .item {
      // 发货、收货
      &.handle-cargo {
        display: flex;

        .item-left,
        .item-right {
          flex: 1;
        }

        .item-left {
          margin-right: 8px;
        }

        .item-right {
          margin-left: 8px;
        }
      }

      // 区块标题
      &-title {
        height: 40px;
        line-height: 40px;
        padding-left: 35px;
        color: #333;
        background-color: #dddddd;

        font: {
          size: 16px;
          weight: 700;
        }
      }

      /deep/ .item-content {
        .el-row {
          width: 100%;

          // 添加货物信息
          &.add-msg {
            margin-top: 15px;
            color: #03a9f4;
            font-size: 14px;
            text-align: center;
            cursor: pointer;
          }
        }

        .el-input.el-input--mini {
          width: 400px;
        }

        .el-table {
          .el-form-item.el-form-item--mini {
            margin-bottom: 0;
          }

          .el-form-item__content {
            margin-left: 0 !important;
          }

          .cargo {
            &-name .el-input.el-input--mini {
              width: 220px;
            }

            &-num,
            &-weight,
            &-volume {
              .el-input.el-input--mini {
                width: 110px;
              }
            }

            &-unit {
              .el-input.el-input--mini {
                width: 80px;
              }
            }

            &-temp,
            &-hum {
              .el-input.el-input--mini {
                width: 100px;
              }
            }

            &-remake {
              .el-input.el-input--mini {
                width: 300px;
              }
            }

            &-delete {
              border: 1px solid #333;
              padding: 4px;
              color: #333;
              font: {
                size: 12px;
                weight: 700;
              }
              border-radius: 50%;
              cursor: pointer;
            }
          }
        }
      }
    }
  }

  // 底部
  .footer-section {
    height: 69px;
    line-height: 69px;
    text-align: center;
    border-top: 1px solid #c9c9c9;
  }

  /deep/ .el-dialog {
    position: relative;
    font-size: 12px;

    .el-dialog__header {
      padding: 0;
    }

    .el-dialog__body {
      padding: 15px;
    }

    .wrapper {
      .main-title {
        text-align: center;
      }

      .dialog-item {
        &-title {
          display: inline-block;
          height: 24px;
          padding: 0 2px;
          line-height: 24px;
          background-color: #e4e4e4;
          font: {
            size: 14px;
            weight: 700;
          }
        }

        &-content {
          font-size: 12px;

          &.table {
            overflow: auto;
          }
        }

        .task-msg {
          display: flex;
          flex-direction: row;
        }

        .item-content_left,
        .item-content_right {
          flex: 1;

          .title {
            padding: 0;
            margin: 5px 0;
            font-size: 14px;
          }
        }

        .tables {
          width: 100%;
          font-size: 12px;
          margin-top: 6px;

          tbody {
          }

          th,
          td {
            // text-align: center;
            // word-break: keep-all;
            white-space: nowrap;
            // text-overflow: ellipsis;
            // overflow: hidden;
            padding: 2px 5px;
          }
        }
      }

      .el-form-item.el-form-item--mini {
        margin-bottom: 0;
      }
      .el-form-item__label {
        font-size: 12px;
      }
      .el-form-item__content {
        font-size: 12px;
        margin-left: 0;
      }
    }

    .image {
      position: absolute;
      top: 60px;
      right: 20px;
      width: 60px;
      height: 60px;
      background: url("~@/assets/images/emergencyManage/other/wx.png") no-repeat;
      background-size: 100% 100%;
    }
  }
}
</style>
